<template>
  <li class="tutorials-list-row">
    <button
      type="button"
      class="tutorials-list-row__button"
      :disabled="disabled"
      @click="emit('click')"
    >
      <span class="tutorials-list-row__body">
        <span class="tutorials-list-row__name">{{ name }}</span>
        <span
          v-if="secondaryText"
          class="tutorials-list-row__secondary"
        >
          {{ secondaryText }}
        </span>
        <span
          v-if="trailingText"
          class="tutorials-list-row__trailing"
        >
          {{ trailingText }}
        </span>
        <div
          v-if="infoText"
          class="tutorials-list-row__cta"
        >
          <ui-icon
            type="round"
            class="tutorials-list-row__cta-icon"
          >
            info
          </ui-icon>
          <span class="tutorials-list-row__cta-text">{{ infoText }}</span>
        </div>
      </span>
      <ui-icon
        type="round"
        class="tutorials-list-row__chevron"
      >
        chevron_right
      </ui-icon>
    </button>
  </li>
</template>

<script setup>
defineProps({
  name: {
    type: String,
    required: true,
  },
  secondaryText: {
    type: String,
    default: '',
  },
  trailingText: {
    type: String,
    default: '',
  },
  infoText: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click']);
</script>

<style lang="scss" scoped>
.tutorials-list-row {
  &__button {
    @apply tw-flex tw-w-full tw-items-center tw-gap-3 tw-border-0 tw-border-b tw-bg-transparent tw-px-4 tw-py-5 tw-text-left;
    @apply tw-cursor-pointer;
    border-bottom: 1px solid theme('colors.border.base');
    transition: background-color 0.15s ease-in-out;

    &:hover:not(:disabled) {
      @apply tw-bg-grey-light;
    }

    &:disabled {
      @apply tw-cursor-not-allowed tw-opacity-50;
    }
  }

  &__body {
    @apply tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-gap-0.5;
  }

  &__name {
    @apply tw-text-xl tw-font-medium tw-text-black-870;
  }

  &__secondary {
    @apply tw-pb-3 tw-text-base tw-font-regular tw-text-black-500;
  }

  &__trailing {
    @apply tw-text-xs tw-font-regular tw-text-text-disable;
  }

  &__cta {
    @apply tw-mt-0 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded tw-bg-informational-chip-bg tw-px-2 tw-py-1.5;
  }

  &__cta-icon {
    @apply tw-shrink-0 tw-p-0 tw-text-informational-light-xx;
  }

  &__cta-text {
    @apply tw-text-xs tw-text-text-secondary;
  }

  &__chevron {
    @apply tw-text-black;
  }
}
</style>
